import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';

interface EditorQuillProps {
  content: string;
  onChange: (content: string) => void;
  width?: string | number;
  height: string | number;
}

const EditorWrapper = styled.div`
  display: flex;

  .quill {
    display: flex;
    flex-direction: column;
  }

  .ql-container {
    flex-grow: 1;
    max-height: 400px;
  }
`;

const EditorQuill = ({ width = '100%', height = 400, content, onChange }: EditorQuillProps) => {
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],
      ['link', 'image', 'video', 'formula'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction

      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: ['right', 'center', 'justify'] }],

      ['clean'], // remove formatting button
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'link',
    'color',
    'image',
    'background',
    'align',
  ];

  return (
    <EditorWrapper style={{ width, minHeight: height }}>
      <ReactQuill
        theme="snow"
        modules={modules}
        formats={formats}
        value={content}
        onChange={onChange}
      />
    </EditorWrapper>
  );
};

export default EditorQuill;
